/* ============================================================
   Three Six Views Cart Drawer — UpCart-style behaviour
   Slide-out · inline AJAX · conditional upsell carousel · straight
   to checkout. Intercepts Dawn's add-to-cart forms + the header cart
   icon, and neutralises the live UpCart app so there is never a double
   drawer while the app embed is still enabled.
   ============================================================ */
/* ---------- DEAD-END SENTINEL (standalone — must survive anything) ----------
   Ported from kh 2026-08-04 after a Kaching Bundles app update silently killed
   Konah Home's add-to-cart -> drawer -> checkout path for ~15h (app JS changes
   with no theme push and can swallow click/submit events before the drawer
   sees them). Guarantee: after any tap on something clickable, if the cart
   count GREW but no drawer is visible ~1.5-4s later, send the buyer to /cart.
   Standalone IIFE, window-capture pointerdown, once per pageview, never on
   /cart or /checkout pages. See konah-home/kh-cart-drawer.js for full spec. */
(function () {
  'use strict';
  var busy = false, done = false;
  function count(cb) {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cb(c && typeof c.item_count === 'number' ? c.item_count : null); })
        .catch(function () { cb(null); });
    } catch (e) { cb(null); }
  }
  function drawerVisible() {
    var d = document.getElementById('tsvcdDrawer');
    return !!(d && !d.hidden && d.classList.contains('is-open'));
  }
  function onCartOrCheckout() {
    var p = location.pathname;
    return p.indexOf('/cart') === 0 || p.indexOf('checkout') !== -1;
  }
  window.addEventListener('pointerdown', function (e) {
    try {
      if (busy || done || onCartOrCheckout()) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('button, [role="button"], [type="submit"], [name="add"], input, a, form, [class*="kaching"], [class*="bundle"], [class*="atc"], [class*="add-to-cart"]')) return;
      busy = true;
      var baseline = null;
      count(function (n) { baseline = n; });
      [1500, 2600, 3900].forEach(function (ms) {
        setTimeout(function () {
          try {
            if (done || drawerVisible() || onCartOrCheckout()) return;
            count(function (n) {
              if (done || drawerVisible() || onCartOrCheckout()) return;
              if (baseline !== null && n !== null && n > baseline) {
                done = true;
                window.location.href = '/cart';
              }
            });
          } catch (err) {}
        }, ms);
      });
      setTimeout(function () { busy = false; }, 4600);
    } catch (err) {}
  }, true);
})();

(function () {
  'use strict';

  /* ---------- neutralise UpCart (idempotent, childList-only, self-disconnecting) ---------- */
  var kcObs;
  function killUpCart() {
    if (kcObs) kcObs.disconnect();
    if (document.body.classList.contains('upcartPopupShow')) {
      document.body.classList.remove('upcartPopupShow');
    }
    if (kcObs) { try { kcObs.observe(document.body, { childList: true }); } catch (e) {} }
  }
  try { kcObs = new MutationObserver(killUpCart); kcObs.observe(document.body, { childList: true }); } catch (e) {}
  killUpCart();

  var overlay = document.getElementById('tsvcdOverlay');
  var drawer  = document.getElementById('tsvcdDrawer');
  if (!drawer || !overlay) return;

  var closeBtn    = document.getElementById('tsvcdClose');
  var itemsEl     = document.getElementById('tsvcdItems');
  var countEl     = document.getElementById('tsvcdCount');
  var footerEl    = document.getElementById('tsvcdFooter');
  var lowStockEl  = document.getElementById('tsvcdLowStock');
  var lowTextEl   = document.getElementById('tsvcdLowStockText');
  var upsellEl    = document.getElementById('tsvcdUpsell');
  var upsellTrack = document.getElementById('tsvcdUpsellTrack');
  var checkoutTotalEl = document.getElementById('tsvcdCheckoutTotal');
  var rewardMsgEl = document.getElementById('tsvcdRewardMsg');
  var barFillEl   = document.getElementById('tsvcdBarFill');

  var CFG    = window.tsvcdConfig || {};
  var THRESH = CFG.threshold || 5000;
  var RULES  = CFG.upsellRules || [];

  /* ---------- speed state (optimistic UI) ----------
     pendingQty holds quantities the user has tapped to but the server hasn't
     confirmed yet; render() must never clobber those rows. lastKeysSig lets
     render() skip full innerHTML rebuilds (and image reloads) when the set of
     cart lines is unchanged. lastUpsellSig caches the upsell fetch. */
  var pendingQty = {}, qtyTimers = {};
  var lastKeysSig = null, lastUpsellSig = null;

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var amt = (cents || 0) / 100.0;
    function commas(s) { return s.replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      if (key === 'amount_no_decimals') return commas(Math.round(amt).toFixed(0) + '.').slice(0, -1);
      if (key === 'amount_with_comma_separator') return commas(amt.toFixed(2)).replace('.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return commas(Math.round(amt).toFixed(0));
      return commas(amt.toFixed(2));
    });
  }

  /* ---------- open / close ---------- */
  function open() {
    overlay.hidden = false; drawer.hidden = false;
    void drawer.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  closeBtn && closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function thumb(url, px) { return url ? url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + px + 'x' + px + '$1$2') : ''; }

  var TRASH = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>';

  function itemHTML(it) {
    var img = it.image || (it.featured_image && it.featured_image.url) || '';
    if (img) img = thumb(img, 200);
    var variant = (it.variant_title && it.variant_title !== 'Default Title')
      ? '<div class="tsvcd-item-variant">' + esc(it.variant_title) + '</div>' : '';
    var cmpUnit = it.original_price && it.original_price > it.final_price ? it.original_price : 0;
    var cmpLine = cmpUnit ? cmpUnit * it.quantity : 0;
    var compare = (cmpLine > it.final_line_price)
      ? '<span class="tsvcd-price-compare">' + formatMoney(cmpLine) + '</span>' : '';
    return '' +
      '<div class="tsvcd-item" data-key="' + esc(it.key) + '">' +
        '<a class="tsvcd-item-img" href="' + esc(it.url) + '">' +
          (img ? '<img src="' + esc(img) + '" width="88" height="88" loading="lazy" alt="' + esc(it.product_title) + '">' : '') +
        '</a>' +
        '<div class="tsvcd-item-main">' +
          '<div class="tsvcd-item-titlerow">' +
            '<span class="tsvcd-item-title">' + esc(it.product_title) + '</span>' +
            '<button class="tsvcd-remove" data-key="' + esc(it.key) + '" type="button" aria-label="Remove">' + TRASH + '</button>' +
          '</div>' +
          variant +
          '<div class="tsvcd-item-bottom">' +
            '<div class="tsvcd-qty">' +
              '<button type="button" data-action="decrease" data-key="' + esc(it.key) + '" aria-label="Decrease quantity">−</button>' +
              '<span class="tsvcd-qty-val">' + it.quantity + '</span>' +
              '<button type="button" data-action="increase" data-key="' + esc(it.key) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="tsvcd-item-price">' + compare +
              '<span class="tsvcd-price-final">' + formatMoney(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function syncHeaderBubble(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span>';
        icon.appendChild(bubble);
      }
      var span = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
      if (span) span.textContent = count < 100 ? count : '';
    } else if (bubble) { bubble.remove(); }
  }

  /* Fast path: update qty/prices on existing rows without rebuilding the DOM
     (keeps <img> nodes alive — no reload/flicker). Skips rows with unconfirmed
     optimistic quantities so the user's taps are never visually reverted. */
  function renderInPlace(cart) {
    cart.items.forEach(function (it) {
      var row = itemsEl.querySelector('.tsvcd-item[data-key="' + it.key + '"]');
      if (!row) return;
      if (!pendingQty.hasOwnProperty(it.key)) {
        var v = row.querySelector('.tsvcd-qty-val');
        if (v) v.textContent = it.quantity;
        row.classList.remove('tsvcd-item--removing');
      }
      var pf = row.querySelector('.tsvcd-price-final');
      if (pf) pf.textContent = formatMoney(it.final_line_price);
      var cmpUnit = it.original_price && it.original_price > it.final_price ? it.original_price : 0;
      var cmpLine = cmpUnit ? cmpUnit * it.quantity : 0;
      var pc = row.querySelector('.tsvcd-price-compare');
      if (cmpLine > it.final_line_price) {
        if (pc) { pc.textContent = formatMoney(cmpLine); }
        else {
          var pr = row.querySelector('.tsvcd-item-price');
          if (pr) pr.insertAdjacentHTML('afterbegin', '<span class="tsvcd-price-compare">' + formatMoney(cmpLine) + '</span>');
        }
      } else if (pc) { pc.remove(); }
    });
  }

  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    syncHeaderBubble(cart.item_count);

    if (cart.total_price >= THRESH) {
      rewardMsgEl.innerHTML = 'Congrats — you’ve unlocked <b>free shipping!</b>';
    } else {
      rewardMsgEl.innerHTML = 'You’re <b>' + formatMoney(THRESH - cart.total_price) + '</b> away from free shipping!';
    }
    if (barFillEl) barFillEl.style.width = Math.min(100, Math.round((cart.total_price * 100) / THRESH)) + '%';

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="tsvcd-empty">' +
          '<svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<p>Your cart is empty</p>' +
          '<a href="/collections/all">Continue shopping</a>' +
        '</div>';
      footerEl && footerEl.classList.add('is-hidden');
      lowStockEl && lowStockEl.classList.add('is-hidden');
      upsellEl && upsellEl.classList.add('is-hidden');
      lastKeysSig = null; lastUpsellSig = null;
    } else {
      var keysSig = cart.items.map(function (i) { return i.key; }).join('|');
      if (keysSig === lastKeysSig && itemsEl.querySelector('.tsvcd-item')) {
        renderInPlace(cart);
      } else {
        itemsEl.innerHTML = cart.items.map(itemHTML).join('');
        lastKeysSig = keysSig;
      }
      footerEl && footerEl.classList.remove('is-hidden');
      lowStockEl && lowStockEl.classList.remove('is-hidden');
      if (lowTextEl) {
        lowTextEl.textContent = cart.item_count === 1
          ? 'One item in your cart is low in stock.'
          : 'Some items in your cart are low in stock.';
      }
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(cart.total_price);
      loadUpsells(cart);
    }
  }

  /* ---------- conditional upsell engine ("You'll love these") ----------
     RULES = [{trigger:[handles], pool:[handles]}]. A rule fires when the cart
     contains any of its trigger handles; the union of fired pools (minus items
     already in cart) is shown, in configured order. Mirrors Konah's UpCart. */
  function loadUpsells(cart) {
    if (!upsellEl || !upsellTrack) return;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.handle] = true; });
    var wanted = [];
    RULES.forEach(function (rule) {
      var fired = (rule.trigger || []).some(function (h) { return inCart[h]; });
      if (fired) {
        (rule.pool || []).forEach(function (h) { if (!inCart[h] && wanted.indexOf(h) === -1) wanted.push(h); });
      }
    });
    if (!wanted.length) { upsellEl.classList.add('is-hidden'); lastUpsellSig = null; return; }
    /* cache: same wanted-set already rendered → no refetch, no rebuild */
    var sig = wanted.join('|');
    if (sig === lastUpsellSig && upsellTrack.children.length) {
      upsellEl.classList.remove('is-hidden');
      return;
    }
    Promise.all(wanted.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(function (p) { return p && p.available !== false; });
      if (!valid.length) { upsellEl.classList.add('is-hidden'); lastUpsellSig = null; return; }
      upsellTrack.innerHTML = valid.map(upsellCardHTML).join('');
      upsellEl.classList.remove('is-hidden');
      lastUpsellSig = sig;
      updateArrows();
    });
  }

  function upsellCardHTML(p) {
    var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
    if (!variants.length) variants = p.variants || [];
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    img = thumb(img, 160);
    var price = variants[0] ? variants[0].price : p.price;
    var url = '/products/' + p.handle;
    var select = '';
    if (variants.length > 1) {
      select = '<select class="tsvcd-upsell-select" aria-label="Choose option">' +
        variants.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') +
      '</select>';
    }
    var firstVid = variants[0] ? variants[0].id : '';
    return '' +
      '<div class="tsvcd-upsell-card">' +
        '<a class="tsvcd-upsell-img" href="' + esc(url) + '">' + (img ? '<img src="' + esc(img) + '" loading="lazy" alt="' + esc(p.title) + '">' : '') + '</a>' +
        '<div class="tsvcd-upsell-info">' +
          '<span class="tsvcd-upsell-name">' + esc(p.title) + '</span>' +
          '<span class="tsvcd-upsell-price">' + formatMoney(price) + '</span>' +
          '<div class="tsvcd-upsell-row">' + select +
            '<button class="tsvcd-upsell-add" type="button" data-vid="' + firstVid + '">Add</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function updateArrows() {
    var prev = document.getElementById('tsvcdUpsellPrev');
    var next = document.getElementById('tsvcdUpsellNext');
    if (!prev || !next) return;
    var max = upsellTrack.scrollWidth - upsellTrack.clientWidth - 2;
    prev.disabled = upsellTrack.scrollLeft <= 2;
    next.disabled = upsellTrack.scrollLeft >= max;
  }

  /* ---------- cart API ---------- */
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return fetchCart().then(render); }
  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }
  function addItem(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function () { return refresh(); }).then(open);
  }
  function addFormData(fd) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); }).then(function () { return refresh(); }).then(open);
  }

  window.tsvCartDrawer = { open: open, close: close, addItem: addItem, refresh: refresh };

  /* ---------- fetch-layer net (tsv-only): Kaching Bundles hijacks ATC clicks
     and POSTs /cart/add itself — no submit event fires. Any successful
     cart-add from ANY script refreshes + opens the drawer (UpCart behavior). */
  var _origFetch = window.fetch;
  window.fetch = function () {
    var url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = _origFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      p.then(function (res) {
        if (res && res.ok) { refresh().then(open); }
      }).catch(function () {});
    }
    return p;
  };

  /* ---------- delegated: qty / remove (OPTIMISTIC — instant UI, debounced sync) ----------
     The number bumps at tap time (0ms feedback); one /cart/change.js call with
     the final quantity fires 300ms after the last tap. Rapid taps = one request. */
  function queueQty(key, qty) {
    pendingQty[key] = qty;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      var q = pendingQty[key];
      delete pendingQty[key]; delete qtyTimers[key];
      changeQty(key, q);
    }, 300);
  }
  itemsEl.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.tsvcd-qty button');
    if (qtyBtn) {
      var row = qtyBtn.closest('.tsvcd-item');
      var key = qtyBtn.getAttribute('data-key');
      var valEl = row.querySelector('.tsvcd-qty-val');
      var cur = pendingQty.hasOwnProperty(key) ? pendingQty[key] : (parseInt(valEl.textContent, 10) || 0);
      var next = qtyBtn.getAttribute('data-action') === 'increase' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      valEl.textContent = next;
      row.classList.toggle('tsvcd-item--removing', next === 0);
      queueQty(key, next);
      return;
    }
    var rm = e.target.closest('.tsvcd-remove');
    if (rm) {
      var k = rm.getAttribute('data-key');
      var r2 = rm.closest('.tsvcd-item');
      if (r2) r2.classList.add('tsvcd-item--removing');
      queueQty(k, 0);
    }
  });

  /* ---------- delegated: upsell add / variant select / arrows ---------- */
  if (upsellEl) {
    upsellEl.addEventListener('change', function (e) {
      var sel = e.target.closest('.tsvcd-upsell-select');
      if (!sel) return;
      var btn = sel.parentElement.querySelector('.tsvcd-upsell-add');
      var opt = sel.options[sel.selectedIndex];
      if (btn) btn.setAttribute('data-vid', sel.value);
      var priceEl = sel.closest('.tsvcd-upsell-info').querySelector('.tsvcd-upsell-price');
      if (priceEl && opt && opt.getAttribute('data-price')) priceEl.textContent = formatMoney(parseInt(opt.getAttribute('data-price'), 10));
    });
    upsellEl.addEventListener('click', function (e) {
      var add = e.target.closest('.tsvcd-upsell-add');
      if (add) {
        var vid = add.getAttribute('data-vid');
        if (vid) { add.textContent = 'Adding…'; add.disabled = true; addItem(vid, 1); }
        return;
      }
      var prev = e.target.closest('#tsvcdUpsellPrev');
      var next = e.target.closest('#tsvcdUpsellNext');
      if (prev || next) {
        upsellTrack.scrollBy({ left: (prev ? -1 : 1) * upsellTrack.clientWidth, behavior: 'auto' });
        updateArrows();
      }
    });
    upsellTrack && upsellTrack.addEventListener('scroll', updateArrows, { passive: true });
  }

  /* ---------- checkout: straight to checkout, skip cart page ---------- */
  var checkoutBtn = document.getElementById('tsvcdCheckout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      checkoutBtn.style.opacity = '.7';
      window.location.href = '/checkout';
    });
  }

  /* ---------- intercept ADD-TO-CART forms (capture phase → beats Dawn) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    var submitBtn = form.querySelector('[type="submit"], [name="add"]');
    if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
    /* perceived speed: open the drawer immediately with a subtle loading state;
       the new item pops in when the add completes */
    open();
    drawer.classList.add('is-adding');
    addFormData(new FormData(form)).catch(function () {}).then(function () {
      drawer.classList.remove('is-adding');
      if (submitBtn) submitBtn.removeAttribute('aria-disabled');
    });
  }, true);

  /* ---------- intercept cart triggers → open drawer (never /cart) ---------- */
  function bindCartTriggers() {
    var sels = '#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], [data-tsv-cart-open]';
    document.querySelectorAll(sels).forEach(function (el) {
      if (el.__tsvBound) return; el.__tsvBound = true;
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); refresh(); open(); });
    });
  }
  bindCartTriggers();
  document.addEventListener('DOMContentLoaded', bindCartTriggers);
})();
